import * as React from 'react';
import * as _ from "lodash";
import { NavLink } from 'react-router-dom';
import CenterSelect from "./center-select"
import { CenterMenuWrapper, InverseDropdown } from './styles'
import { ICenter, ICenterBase, IGroup } from '@nkr/models/index';
import ReactHtmlParser from 'react-html-parser';
import { Label, Navbar, OverlayTrigger, Popover } from 'react-bootstrap';
import MediaQuery from 'react-responsive';
import { useAppHookContext } from '@nkr/utils/rest-api/useAppHookContext';
import { OrganType } from '@nkr/enums/organ-type';

interface IProps {
    firstName: string,
    lastName: string,
    username: string,
    currentUrl: string,
    centerId: number,
    centerAlias: string,
    center: ICenter,
    centerList: ICenterBase[]
    notifications: number,
    group: IGroup,
    organ: string,
    organType: OrganType,
    onShowNotifications: () => void
}

const CenterMenus = (props: IProps) => {
    const [defaultOverlayShown, setDefaultOverlayShown] = React.useState(false);

    const getOverlay = () => {
        let note = props.notifications > 0 ? "Click here to view new notifications" : "No new notifications";

        return (
            <Popover id="alertpop" style={props.notifications > 0 ? { color: 'green', paddingTop: '0px', width: "100%", display: "visible" } : { color: '#337ab7', paddingTop: '0px', width: "100%" }}>
                {ReactHtmlParser(note)}
            </Popover>
        );
    };

    const handleShowDefaultOverlay = () => {
        setDefaultOverlayShown(false);
    };

    const isMicrositeParticipant = props.center ? props.center.isMicrositeParticipant : false;
    const isFollowUpParticipant = props.center ? props.center.isFollowUpParticipant : false;
    const isDashPlParticipant = props.center ? props.center.dashDomain.length > 1 : false;
    const isSuperUser = props.group.isSuper;
    const linkStyles = { paddingTop: 6, paddingBottom: 6 }

    const show = props.organType == OrganType.Kidney;

    const actionCenterItems = [
        { label: <>To Do</>, href: `/center/${props.centerId}`, show: true },
        { label: <>Pending Swaps</>, href: `/center/${props.centerId}/action-center/pending-swaps`, show },
        { label: <>Move Tracker</>, href: `/center/${props.centerId}/action-center/move-tracker`, show },
        { label: <>Center Performance</>, href: `/center/${props.centerId}/action-center/center-performance`, show },
        { label: <>XM Tracking</>, href: `/center/${props.centerId}/action-center/xm-tracking/by-your-center`, show },
        { label: <>Serology Tracking</>, href: `/center/${props.centerId}/action-center/serology-tracking/by-your-center`, show },
        { label: <>Expert System</>, href: `/center/${props.centerId}/action-center/expert-system`, show: isDashPlParticipant && show },
    ]

    const reportingItems = [
        { label: <>DASHBoard</>, href: `/center/${props.centerId}/reports/dash-board/summary`, show: true },
        { label: <>Center CPR Audit</>, href: `/center/${props.centerId}/reports/my-center/cpr-score-audit-report`, show },
        { label: <>Center FCR Audit</>, href: `/center/${props.centerId}/reports/my-center/fcr-score-audit-report`, show },
        { label: <>Center Compliance Info</>, href: `/center/${props.centerId}/reports/all-centers/compliance`, show },
        { label: <>RCCAP Management</>, href: `/center/${props.centerId}/reports/my-center/rccap`, show },
    ]

    return (
        <>
            <MediaQuery maxWidth={909}>
                <CenterMenuWrapper className='nkr-menu' style={{ paddingBottom: '0px', paddingTop: '0px' }}>
                    <div className='navbar navbar-inverse' style={{ borderRadius: 0, paddingBottom: '0px', paddingTop: '0px', marginBottom: 0 }}>
                        <div className='navbar-header' style={{ paddingTop: 3 }}>
                            <a href='https://www.kidneyregistry.org' className='navbar-brand' style={{ marginTop: 6, marginRight: 5, padding: 0, height: 'initial' }} target='_blank'>
                                <img alt='NKR' src='/images/logo.png' style={{ height: 25 }} />
                            </a>

                            <Navbar.Toggle type='button' className='navbar-toggle' data-toggle='collapse' data-target='.navbar-collapse' style={{ marginTop: 10, marginLeft: 5 }} />

                            <div style={{ paddingTop: '2px' }}>
                                {isSuperUser ?
                                    <CenterSelect
                                        centerId={props.centerId}
                                        centerList={props.centerList}
                                        onClick={handleShowDefaultOverlay}
                                    />
                                    :
                                    <Navbar.Text pullRight style={{ paddingTop: 6, paddingBottom: 6, margin: 0 }}>
                                        {props.centerAlias}
                                    </Navbar.Text>
                                }

                                <div>
                                    <OverlayTrigger placement='bottom' trigger={['hover', 'focus']} overlay={getOverlay()} rootClose={!defaultOverlayShown} defaultOverlayShown={defaultOverlayShown} animation={true} >
                                        <div>
                                            <Label bsStyle={props.notifications > 0 ? 'success' : 'default'} style={{ marginLeft: 5, padding: 5 }} onClick={props.onShowNotifications}>{props.notifications}</Label>
                                        </div>
                                    </OverlayTrigger>
                                </div>
                            </div>
                        </div>
                        <div className='navbar-collapse collapse'>
                            <ul className='nav navbar-nav'>
                                <li className='dropdown'>
                                    <a href='#' style={linkStyles} className='dropdown-toggle' data-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>Action Center <span className='caret'></span></a>
                                    <InverseDropdown className='dropdown-menu'>
                                        {actionCenterItems.filter(x => x.show).map((item, index) =>
                                            <li><a key={'action-center-' + index} href={item.href}>{item.label}</a></li>
                                        )}
                                    </InverseDropdown>
                                </li>

                                {props.organType == OrganType.Kidney && (
                                    <li className='dropdown'>
                                        <a href='#' style={linkStyles} className='dropdown-toggle' data-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>Recipients <span className='caret'></span></a>
                                        <InverseDropdown className='dropdown-menu'>
                                            <li>
                                                <a href={`/center/${props.centerId}/recipients`}>Recipients</a>
                                                <a href={`/center/${props.centerId}/recipients/voucher-holders`}>Voucher Holder Recipients</a>
                                                <a href={`/center/${props.centerId}/recipients`}>Paired Recipients</a>
                                                <a href={`/center/${props.centerId}/recipients/transplanted-recipients`}>NEW! Transplanted Recipients</a>
                                                <a href={`/center/${props.centerId}/recipients/import-waitlist`}>Import Waitlist</a>
                                                <a href={`/center/${props.centerId}/recipients/patient-intake/to-do`}>Patient Intake</a>
                                            </li>
                                        </InverseDropdown>
                                    </li>
                                )}

                                <li className='dropdown'>
                                    <a href='#' style={linkStyles} className='dropdown-toggle' data-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>Donors <span className='caret'></span></a>
                                    <InverseDropdown className='dropdown-menu'>
                                        <li><a href={`/center/${props.centerId}/donors/search`}>Donor Search</a></li>

                                        {isMicrositeParticipant && (
                                            <li><a href={`/center/${props.centerId}/microsite/pending-center`}>Microsites</a></li>
                                        )}

                                        <li><a href={`/center/${props.centerId}/donors/donor-intake/to-do`}>Donor Intake</a></li>
                                        <li><a href={`/center/${props.centerId}/donors/swap`}>Swap Donors</a></li>

                                        {isFollowUpParticipant && (
                                            <li><a href={`/center/${props.centerId}/follow-up/surveys`}>Donor Follow-Up</a></li>
                                        )}

                                        <li><a href={`/center/${props.centerId}/donors/watr`}>Donor Shield Claims</a></li>
                                    </InverseDropdown>
                                </li>

                                <li className='dropdown'>
                                    <a href='#' style={linkStyles} className='dropdown-toggle' data-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>Reporting <span className='caret'></span></a>
                                    <InverseDropdown className='dropdown-menu'>
                                        {reportingItems.filter(x => x.show).map((item, index) =>
                                            <li><a key={'reporting-' + index} href={item.href}>{item.label}</a></li>
                                        )}
                                    </InverseDropdown>
                                </li>

                                <li className='dropdown'>
                                    <a href='#' style={linkStyles} className='dropdown-toggle' data-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>Communication <span className='caret'></span></a>
                                    <InverseDropdown className='dropdown-menu'>
                                        <li>
                                            <a href={`/center/${props.centerId}/action-center/support`}>Support Tickets</a>
                                            <a href={"https://youtube.com/playlist?list=PLAvrjwslctLIzQtaHfA-fmnmWjuElBd5H"} target={"_blank"}>Training Videos</a>
                                            <a href={"https://www.kidneyregistry.com/training-materials/?pwd=NKR_Ed2024*2"} target={"_blank"}>Training Materials</a>
                                            <a href={`/center/${props.centerId}/reports/all-centers/`}>Member Center Directory</a>
                                            <a href={`/center/${props.centerId}/action-center/swap-quality-issues/list/pending-response`}>Swap Quality System</a>
                                            {props.organType == OrganType.Kidney && (
                                                <>
                                                    <a href={"https://www.kidneyregistry.com/ped-gallery/"} target={"_blank"}>View Pediatric Gallery</a>
                                                    <a href={`/center/${props.centerId}/network-email-repository`}>NKR Network Email Repository</a>
                                                </>
                                            )}
                                        </li>
                                    </InverseDropdown>
                                </li>

                                <li>
                                    <a style={linkStyles} href={`/center/${props.centerId}/billing/${props.organType == OrganType.Kidney ? 'accounts-receivable' : 'accounts-payable-total'}`}>Billing</a>
                                </li>

                                <li>
                                    <a style={linkStyles} href={`/center/${props.centerId}/profile/edit`}>Settings</a>
                                </li>

                                <li className='dropdown'>
                                    <a href='#' style={linkStyles} className='dropdown-toggle' data-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>Welcome, {props.firstName} {props.lastName} <span className='caret'></span></a>
                                    <InverseDropdown className='dropdown-menu'>
                                        <li>
                                            <a href={'center/' + props.centerId}>Member Home</a>
                                            <NavLink to={'/manage-account'}>Manage Account</NavLink>
                                            <NavLink to={'/logout?next=' + props.currentUrl} activeClassName='active'>Logout</NavLink>
                                        </li>
                                    </InverseDropdown>
                                </li>
                            </ul>
                        </div>
                    </div>
                </CenterMenuWrapper>
            </MediaQuery>

            <MediaQuery minWidth={910}>
                <CenterMenuWrapper className={`nkr-menu ${props.organ}registry-menu`} style={{ paddingBottom: 0, paddingTop: 0 }}>
                    <div className='navbar navbar-inverse' style={{ borderRadius: 0, paddingBottom: 0, paddingTop: 0, marginBottom: 0 }}>
                        <div className='navbar-header' style={{ paddingTop: 3 }}>
                            <a href='https://www.kidneyregistry.org' className='navbar-brand' style={{ marginTop: 0, marginRight: 5, padding: 0, height: 'initial' }} target='_blank'>
                                <img alt='NKR' src={`/images/${props.organ}registry-logo.png`} style={{ height: 25 }} />
                            </a>

                            <Navbar.Toggle type='button' className='navbar-toggle' data-toggle='collapse' data-target='.navbar-collapse' style={{ marginTop: 13, marginLeft: 5 }} />
                        </div>
                        <div className='navbar-collapse collapse'>
                            <ul className='nav navbar-nav'>
                                <li className='dropdown'>
                                    <a href='#' style={linkStyles} className='dropdown-toggle' data-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>Action Center <span className='caret'></span></a>
                                    <InverseDropdown className='dropdown-menu'>
                                        {actionCenterItems.filter(x => x.show).map((item, index) =>
                                            <li><a key={'action-center-' + index} href={item.href}>{item.label}</a></li>
                                        )}
                                    </InverseDropdown>
                                </li>

                                {props.organType == OrganType.Kidney && (
                                    <li className='dropdown'>
                                        <a href='#' style={linkStyles} className='dropdown-toggle' data-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>Recipients <span className='caret'></span></a>
                                        <InverseDropdown className='dropdown-menu'>
                                            <li>
                                                <a href={`/center/${props.centerId}/recipients`}>Recipients</a>
                                                <a href={`/center/${props.centerId}/recipients/voucher-holders`}>Voucher Holder Recipients</a>
                                                <a href={`/center/${props.centerId}/recipients`}>Paired Recipients</a>
                                                <a href={`/center/${props.centerId}/recipients/import-waitlist`}>Import Waitlist</a>
                                                <a href={`/center/${props.centerId}/recipients/patient-intake/to-do`}>Patient Intake</a>
                                            </li>
                                        </InverseDropdown>
                                    </li>
                                )}

                                <li className='dropdown'>
                                    <a href='#' style={linkStyles} className='dropdown-toggle' data-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>Donors <span className='caret'></span></a>
                                    <InverseDropdown className='dropdown-menu'>
                                        {props.organType == OrganType.Kidney && (
                                            <li><a href={`/center/${props.centerId}/donors/search`}>Donor Search</a></li>
                                        )}

                                        {isMicrositeParticipant && (
                                            <li><a href={`/center/${props.centerId}/microsite/pending-center`}>Microsites</a></li>
                                        )}

                                        <li><a href={`/center/${props.centerId}/donors/donor-intake/to-do`}>Donor Intake</a></li>

                                        {props.organType == OrganType.Kidney && (
                                            <li><a href={`/center/${props.centerId}/donors/swap`}>Swap Donors</a></li>
                                        )}

                                        {isFollowUpParticipant && props.organType == OrganType.Kidney && (
                                            <li><a href={`/center/${props.centerId}/follow-up/surveys`}>Donor Follow-Up</a></li>
                                        )}

                                        <li><a href={`/center/${props.centerId}/donors/watr`}>Donor Shield Claims</a></li>
                                    </InverseDropdown>
                                </li>

                                <li className='dropdown'>
                                    <a href='#' style={linkStyles} className='dropdown-toggle' data-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>Reporting <span className='caret'></span></a>
                                    <InverseDropdown className='dropdown-menu'>
                                        {reportingItems.filter(x => x.show).map((item, index) =>
                                            <li><a key={'reporting-' + index} href={item.href}>{item.label}</a></li>
                                        )}
                                    </InverseDropdown>
                                </li>

                                <li className='dropdown'>
                                    <a href='#' style={linkStyles} className='dropdown-toggle' data-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>Communication <span className='caret'></span></a>
                                    <InverseDropdown className='dropdown-menu'>
                                        <li>
                                            <a href={`/center/${props.centerId}/action-center/support`}>Support Tickets</a>

                                            {props.organType == OrganType.Kidney && (
                                                <>
                                                    <a href={"https://youtube.com/playlist?list=PLAvrjwslctLIzQtaHfA-fmnmWjuElBd5H"} target={"_blank"}>Training Videos</a>
                                                    <a href={"https://www.kidneyregistry.com/training-materials/?pwd=NKR_Ed2024*2"} target={"_blank"}>Training Materials</a>
                                                    <a href={`/center/${props.centerId}/reports/all-centers/`}>Member Center Directory</a>
                                                    <a href={`/center/${props.centerId}/action-center/swap-quality-issues/list/pending-response`}>Swap Quality System</a>
                                                    <a href={"https://www.kidneyregistry.com/ped-gallery/"} target={"_blank"}>View Pediatric Gallery</a>
                                                    <a href={`/center/${props.centerId}/network-email-repository`}>NKR Network Email Repository</a>
                                                </>
                                            )}
                                        </li>
                                    </InverseDropdown>
                                </li>
                                <li>
                                    <a style={linkStyles} href={`/center/${props.centerId}/billing/${props.organType == OrganType.Kidney ? 'accounts-receivable' : 'accounts-payable-total'}`}>Billing</a>
                                </li>
                                <li>
                                    <a style={linkStyles} href={`/center/${props.centerId}/profile/edit`}>Settings</a>
                                </li>

                                <li className='dropdown'>
                                    <a href='#' style={linkStyles} className='dropdown-toggle' data-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>Welcome, {props.firstName} {props.lastName} <span className='caret'></span></a>
                                    <InverseDropdown className='dropdown-menu'>
                                        <li>
                                            <a href={'center/' + props.centerId}>Member Home</a>
                                            <a href={'/manage-account'}>Manage Account</a>
                                            <NavLink to={'/logout?next=' + props.currentUrl} activeClassName='active'>Logout</NavLink>
                                        </li>
                                    </InverseDropdown>
                                </li>
                            </ul>

                            <div className='navbar-text navbar-right' style={{ margin: 0 }}>
                                <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} title='' >
                                    {isSuperUser ?
                                        <CenterSelect
                                            centerId={props.centerId}
                                            centerList={props.centerList}
                                            onClick={handleShowDefaultOverlay}
                                        />
                                        :
                                        <Navbar.Text pullRight style={{ paddingTop: 6, paddingBottom: 6, margin: 0 }}>
                                            {props.centerAlias}
                                        </Navbar.Text>
                                    }

                                    <div>
                                        <OverlayTrigger placement='bottom' trigger={['hover', 'focus']} overlay={getOverlay()} rootClose={!defaultOverlayShown} defaultOverlayShown={defaultOverlayShown} animation={true} >
                                            <div>
                                                <Label bsStyle={props.notifications > 0 ? 'success' : 'default'} style={{ marginLeft: 5, padding: 5 }} onClick={props.onShowNotifications}>{props.notifications}</Label>
                                            </div>
                                        </OverlayTrigger>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </CenterMenuWrapper>
            </MediaQuery>
        </>
    );
}

export default CenterMenus;
